// @ts-strict-ignore
import { requestApi } from 'api/api'
import { Currency, ExchangeRateResponse } from 'types/types'

export const getFiatCurrencies = (): Promise<Currency[]> => {
  return requestApi({
    url: '/currency/fiat',
    method: 'GET',
    params: {
      pagination: false,
      sort: 'currency.rank',
      order: 'asc',
    },
    authenticated: false,
  })
}

export const getCryptoCurrencies = (): Promise<Currency[]> => {
  return requestApi({
    url: '/currency/crypto',
    method: 'GET',
    params: {
      pagination: false,
      sort: 'rank',
      order: 'asc',
      allowDeposits: true,
      all: false,
    },
    authenticated: false,
  })
}

export const getExchangeRate = (
  fromCode: string,
  toCode: string,
  amount: number | string
): Promise<ExchangeRateResponse> => {
  const canGetExchangeRate = !!(fromCode && toCode && amount)
  if (canGetExchangeRate) {
    return requestApi({
      url: `/currency/convert/${fromCode}/${toCode}`,
      method: 'GET',
      params: {
        amount,
      },
      authenticated: false,
    })
  }
}
